module.exports = __webpack_public_path__ + "img/overview.934b7bf5.png";